module.exports = __webpack_public_path__ + "çalışma masası.jpg?85072f0987876d7b9de1fd1e0f026766";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/çalışma masası.jpg
// module id = 357
// module chunks = 0